import React, { useState } from "react";
import styles from "./AsnPage.module.css";
import "moment/locale/id";
import Header from "../../components/Header/Header";
import checkStatusLogo from "../../icons/check-status.svg";
import { Button, Row } from "react-bootstrap";
import confirmationLogo from "../../icons/confirmation-success.svg";
import { Download } from "react-bootstrap-icons";
import { useParams } from "react-router-dom";

const AsnPdfDownload = () => {
  const { id } = useParams();
  const onClickDownloadPdf = () => {
    window.open(
      `${process.env.REACT_APP_API_URL}web/supplier-onboard/advance-shipping-notice/${id}/advance-shipping-notice-document.pdf`,
      '_blank' 
    );
  }

  return (
    <div className={styles.container}>
      <Header activeKey="/asn" />
      <div className={styles.pageBody}>
        <Row className={styles.confirmationCard}>
          <div className={styles.iconArea}>
            <img src={confirmationLogo} className={styles.iconImage} />
          </div>
          <div className="mt-4 justify-content-center">
            <Row className="mt-4 justify-content-center">
              <div className={styles.textArea}>
                <p>
                  Data ASN anda berhasil disimpan. Pastikan anda melakukan hal
                  berikut :
                </p>
              </div>
            </Row>
            <Row className="mx-auto text-center">
              <p>
                1. Mengirimkan <b>Qty Barang</b> sesuai dengan data yang di
                input
              </p>
            </Row>
            <Row className="mx-auto text-center">
              <p>
                2. Membawa <b>Dokumen ASN</b> dan <b>Dokumen Purchase Order</b>{" "}
                saat pengiriman barang
              </p>
            </Row>
            <Row className="mt-4 justify-content-center">
              <div className={styles.textArea}>
                <a target="_blank" href={""}>
                  <Button type="button" onClick={onClickDownloadPdf} className={styles.btnGreen}>
                    <span className="me-2">
                      <Download />
                    </span>
                    <span>Download Dokumen ASN</span>
                  </Button>
                </a>
              </div>
            </Row>
          </div>
        </Row>
      </div>
    </div>
  );
};

export default AsnPdfDownload;
